import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const ShoppingBagIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    height: size,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M15.75 4.61719H13.5C13.5 2.13094 11.4862 0.117188 9 0.117188C6.51375 0.117188 4.5 2.13094 4.5 4.61719H2.25C1.0125 4.61719 0 5.62969 0 6.86719V20.3672C0 21.6047 1.0125 22.6172 2.25 22.6172H15.75C16.9875 22.6172 18 21.6047 18 20.3672V6.86719C18 5.62969 16.9875 4.61719 15.75 4.61719ZM6.75 9.11719C6.75 9.73594 6.24375 10.2422 5.625 10.2422C5.00625 10.2422 4.5 9.73594 4.5 9.11719V6.86719H6.75V9.11719ZM9 2.36719C10.2375 2.36719 11.25 3.37969 11.25 4.61719H6.75C6.75 3.37969 7.7625 2.36719 9 2.36719ZM13.5 9.11719C13.5 9.73594 12.9937 10.2422 12.375 10.2422C11.7563 10.2422 11.25 9.73594 11.25 9.11719V6.86719H13.5V9.11719Z",
    fill: color
  }));
};
export default ShoppingBagIcon;